import React from 'react';
import { InnerLayout } from '@layout';
import { H1 } from '@heading';
import SocialLink from '@components/SocialLink';
import Intro from './Intro';
import Donate from './Donate';
import Highlights from './Highlights';
import Scholars from './Scholars';
import Pillars from './Pillars';
import GetInTouch from './GetInTouch';
import Breadcrumbs from '@components/Breadcrumbs';
import styles from './DiversityCenter.module.scss';

export default function DiversityCenter({
  title = 'The Center for Diverse Leadership in Science',
  h1 = 'The Center for Diverse Leadership in Science',
  breadcrumbs,
  currentPageLabel,
  showBreadcrumbs = true,
  ...restProps
}) {
  return (
    <InnerLayout
      showBreadcrumbs={false}
      showNavigation={false}
      headerContent={
        <HeaderContent
          h1={h1}
          showBreadcrumbs={showBreadcrumbs}
          breadcrumbs={breadcrumbs}
          currentPageLabel={currentPageLabel}
        />
      }
      {...restProps}
    >
      <Intro />
      <Donate />
      <Highlights />
      <Scholars />
      <Pillars />
      <GetInTouch />
    </InnerLayout>
  );
}

function HeaderContent({
  h1,
  showBreadcrumbs,
  breadcrumbs,
  currentPageLabel
}) {
  return (
    <div className={styles.top}>
      <div className={styles.pageTitle}>
        <H1>{h1}</H1>
        {showBreadcrumbs && (
          <Breadcrumbs
            crumbs={breadcrumbs}
            currentPageLabel={currentPageLabel}
          />
        )}
      </div>

      <ul className={styles.socialLinks}>
        <li>
          <SocialLink
            type="twitter"
            url="https://twitter.com/CDLS_UCLA"
          />
        </li>

        <li>
          <SocialLink
            type="facebook"
            url="https://www.facebook.com/CDLSUCLA/"
          />
        </li>

        <li>
          <SocialLink
            type="instagram"
            url="https://www.instagram.com/CDLS_UCLA"
          />
        </li>
      </ul>
    </div>
  );
}
